import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IOrderConfirmationDialogProperties } from './OrderConfirmationDialog.properties';
import OrderConfirmationSchema from './OrderConfirmationDialog.form';
import { useSPContextSelector } from '../Worksale.context';
import Selectors from '../Worksale.selectors';
import { useFetchSalesOrderConfirmation } from 'api/Worksale/worksale';
import { isNull } from 'utils/utils';

const OrderConfirmationDialog = (props: IOrderConfirmationDialogProperties) => {
    const { open, loading, formValues, orderDocumentOutputOptions, setOrderDocumentOutputOptions, clearOrderDocumentOutputOptions, onCancel, onOk, operationInProgress, processSalesOrderQuery, isProcessing } = props;
    const worksaleId = useSPContextSelector(Selectors.WorksaleId) || -1;
    const customerId = useSPContextSelector(Selectors.CustomerId);
    const { data: response } = useFetchSalesOrderConfirmation(worksaleId);
    const inlineResponse = response?.SalesOrderConfirmation.inlineObject;
    const initialValues = React.useMemo(
        () => {
            if (operationInProgress === 'ProcessSale') {
                return processSalesOrderQuery;
            } else {
                return {
                    ...inlineResponse,
                    OutputAcknowledgement: formValues?.OutputAcknowledgement ?? inlineResponse?.OutputAcknowledgement,
                    OrderAcknowledgementOutput: !isNull(orderDocumentOutputOptions) ? orderDocumentOutputOptions : response?.SalesOrderConfirmation.OrderAcknowledgementOutput.inlineObject
                };
            }
        },
        [operationInProgress, processSalesOrderQuery, response]
    );

    const valuesSchema = React.useMemo(() => (response?.SalesOrderConfirmation.schema), [response]);

    React.useEffect(
        () => {
            if (initialValues && open) {
                setOrderDocumentOutputOptions(initialValues?.OrderAcknowledgementOutput);
            } else {
                clearOrderDocumentOutputOptions();
            }
        },
        [initialValues, open]);

    return (
        <div>
            <FormViewModal
                open={open}
                loading={loading}
                title='Order Confirmation'
                formProps={{
                    formSchema: OrderConfirmationSchema,
                    initialValues: {
                        ...initialValues,
                        OrderAcknowledgementOutput: initialValues && initialValues.OrderAcknowledgementOutput ? initialValues.OrderAcknowledgementOutput.Summary : ''
                    },
                    valuesSchema: valuesSchema ? valuesSchema : {},
                    style: { height: '380px', minWidth: '400px' },
                    customerId: customerId
                }}
                actions={[
                    {
                        title: 'Ok',
                        disabled: isProcessing,
                        listener: () => {
                            if (onOk) {
                                onOk({ ...formValues, OrderAcknowledgementOutput: orderDocumentOutputOptions });
                            }
                        }
                    },
                    {
                        title: 'Cancel',
                        isDefault: true,
                        listener: () => {
                            if (onCancel) {
                                onCancel();
                            }
                        },
                    },
                ]}
                dialogActionsButtons={true}
                dialogActionsShadow={false}
            />
        </div>
    );
};

export default OrderConfirmationDialog;
